<template>
    <div class="d-flex flex-column">
      <button v-if="showIconOnly"
        :class="[ getclass ]"
        @click='incrementStep()'
        @focusout="handleFocusOut">
          <div class="d-flex flex-column text-nowrap">
            <div class="mx-2">
              <slot name="icon" v-if="!isWaiting && !stepsComplete"></slot>
              <b-icon v-if="isWaiting" scale="0.9" icon="exclamation-circle-fill"></b-icon>
              <b-icon v-if="stepsComplete" scale="0.9" icon="check" font-scale="2"></b-icon>
            </div>
            <span v-if="currentMessage.trim().length > 0" class="btn_note">{{ currentMessage }}</span>
            <span v-if="isWaiting && currentMessage.trim().length == 0" class="btn_note text-nowrap">Click to confirm</span>
          </div>
      </button>

      <b-button v-else
        :variant="variant"
        :class="[ getclass ]"
        @click='incrementStep()'
        @focusout="handleFocusOut"
        >
        <div class="d-flex flex-column text-nowrap">
          <div class="mx-0">
            <slot name="icon" v-if="!isWaiting && !stepsComplete"></slot>
            <b-icon v-if="isWaiting" scale="0.9" icon="exclamation-circle-fill"></b-icon>
            <b-icon v-if="stepsComplete" scale="0.9" icon="check" font-scale="2"></b-icon>
          </div>
          <span v-if="currentMessage.trim().length > 0" class="btn_note">{{ currentMessage }}</span>
          <span v-if="isWaiting && currentMessage.trim().length == 0" class="btn_note text-nowrap">Click to confirm</span>
        </div>
      </b-button>
    </div>
</template>

<script>
  export default {
    name: 's-confirmation-button',
    props: {
      messages: Array,
      variant: String,
      showIconOnly: Boolean,
    },
    data() {
      return {
        defaultSteps: [
          'Click to confirm',
          'Are you sure?',
          '✔',
        ],
        currentStep: 0,
      }
    },
    computed: {
      messageList() {
        return this.messages ? this.messages : this.defaultSteps
      },
      currentMessage() {
        return this.messageList[this.currentStep]
      },
      lastMessageIndex() {
        return this.messageList.length - 1
      },
      stepsComplete() {
        return this.currentStep === this.lastMessageIndex
      },
      isRestart() {
        return this.currentStep > this.lastMessageIndex
      },
      isWaiting() {
        return this.currentStep > 0 && !this.stepsComplete
      },
      getclass() {
        if(this.isWaiting) { return 'btn__initial waiting' } 
        else if(this.stepsComplete) {
          return 'btn__initial complete'
        } else { return 'btn__initial' }
      }
    },
    methods: {
      incrementStep() {
        this.currentStep++
        if(this.isRestart) this.currentStep = 0
        if (!this.stepsComplete) {
          this.$emit('confirmation-incremented')
        }
      },
      init() {
        this.currentStep = 0
      },
      handleFocusOut() {
        this.init()
      }
    },
    watch : {
      currentStep: function(newValue) {
        if (newValue == 0) this.$emit('confirmation-reset')
      },
      stepsComplete: function(newValue) {
        if(newValue) {
          setTimeout(() =>{
            this.currentStep = 0
            this.$emit('confirmation-success')
          }, 800);
        }
      } 
    }
  }
</script>

<style>
  .btn_note,
  .btn_note:hover {
    font-size: 0.8rem;
  }
  .btn__initial{
    display: block;
    font-size: 0.8em;
    font-weight: 400;
    color: rgba(225, 59, 59, 0.8);
    border: none !important;
    outline: 0;
    cursor: pointer;
    background: transparent !important;
    padding: 0em 0em 0em 0em !important;
  }
  .btn__initial:not(.complete):not(.waiting):hover {
    font-weight: 800;
    border: none !important;
    padding: 0em 0em 0em 0em !important;
  }
  .waiting,
  .waiting:hover {
    color: rgb(225, 59, 59, 0.9);
    font-weight: 800;
    animation: zoom-in-zoom-out 1s ease infinite;
    padding: 0em 0em 0em 0em !important;
    border: none !important;
  }
  .complete {
    color: green !important;
    animation: zoom-confirmation 0.8s ease infinite;
    border: none !important;
    text-decoration: none !important
  }
  @keyframes zoom-in-zoom-out {
    0% { transform: scale(1, 1); }
    50% { transform: scale(0.7, 0.7); }
    100% { transform: scale(1, 1); }
  }
  @keyframes zoom-confirmation {
    0% { transform: scale(1, 1); }
    50% { transform: scale(0, 0); }
    100% { transform: scale(1, 1); }
  }
</style>